/* eslint-disable */
export default {
  logging: '正在记录…',
  logCall: '记录通话',
  editLog: '编辑记录',
  select: '选择匹配记录',
  OnHold: '暂候',
  Ringing: '正在振铃',
  CallConnected: '呼叫已接通',
  unknownUser: '未知用户',
  unknownNumber: '匿名',
  unavailable: '不可用',
  viewDetails: '查看详细信息',
  addEntity: '新建',
  addLog: '记录',
  text: '短信',
  call: '电话',
  missedCall: '未接',
  inboundCall: '入站',
  outboundCall: '呼出',
  answeredBy: '已被以下用户接听：',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"answeredBy"@#@ @source: @#@"Answered by"@#@
